<template>
  <v-row justify="center">
    <v-col cols="12" xl="4" lg="4" md="4" sm="12" xs="12">
      <v-simple-table id="table-custom">
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="font-weight-bold">Riwayat Jabatan :</td>
              <td>{{ lbjab }}</td>
              <td>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="$emit('to-detail', keyjab)"
                  ><v-icon small>keyboard_arrow_right</v-icon></v-btn
                >
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Riwayat Golongan :</td>
              <td>{{ lbgol }}</td>
              <td>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="$emit('to-detail', keygol)"
                  ><v-icon small>keyboard_arrow_right</v-icon></v-btn
                >
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Riwayat Pendidikan :</td>
              <td>{{ lbpen }}</td>
              <td>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="$emit('to-detail', keypen)"
                  ><v-icon small>keyboard_arrow_right</v-icon></v-btn
                >
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Riwayat Diklat :</td>
              <td>{{ lbdik }}</td>
              <td>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="$emit('to-detail', keydik)"
                  ><v-icon small>keyboard_arrow_right</v-icon></v-btn
                >
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Riwayat Kursus :</td>
              <td>{{ lbkur }}</td>
              <td>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="$emit('to-detail', keykur)"
                  ><v-icon small>keyboard_arrow_right</v-icon></v-btn
                >
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Riwayat Cuti :</td>
              <td>{{ lbcut }}</td>
              <td>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="$emit('to-detail', keycut)"
                  ><v-icon small>keyboard_arrow_right</v-icon></v-btn
                >
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Riwayat Tanda Jasa :</td>
              <td>{{ lbtan }}</td>
              <td>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="$emit('to-detail', keytan)"
                  ><v-icon small>keyboard_arrow_right</v-icon></v-btn
                >
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Riwayat Kenaikan Gaji :</td>
              <td>{{ lbgaj }}</td>
              <td>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="$emit('to-detail', keygaj)"
                  ><v-icon small>keyboard_arrow_right</v-icon></v-btn
                >
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Riwayat Kinerja :</td>
              <td>{{ lbkin }}</td>
              <td>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="$emit('to-detail', keykin)"
                  ><v-icon small>keyboard_arrow_right</v-icon></v-btn
                >
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Riwayat Angka Kredit :</td>
              <td>{{ lbang }}</td>
              <td>
                <v-btn
                  icon
                  small
                  color="primary"
                  @click="$emit('to-detail', keyang)"
                  ><v-icon small>keyboard_arrow_right</v-icon></v-btn
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>
<script>
import { mapRiwayatField } from "@/store/helpers";

export default {
  computed: {
    ...mapRiwayatField({
      keyang: "keyang",
      keycut: "keycut",
      keydik: "keydik",
      keygaj: "keygaj",
      keygol: "keygol",
      keyjab: "keyjab",
      keykin: "keykin",
      keykur: "keykur",
      keypen: "keypen",
      keytan: "keytan",
      lbang: "lbang",
      lbcut: "lbcut",
      lbdik: "lbdik",
      lbgaj: "lbgaj",
      lbgol: "lbgol",
      lbjab: "lbjab",
      lbkur: "lbkur",
      lbkin: "lbkin",
      lbpen: "lbpen",
      lbtan: "lbtan"
    })
  },
  methods: {
    handleToggle() {
      this.$emit("toggle");
    }
  }
};
</script>
<style lang="scss">
#table-custom.v-data-table {
  color: #717171 !important;
  .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 0.675rem;
  }
}
#table-custom .v-input {
  font-size: 0.675rem;
}
</style>
